import { Component, Input } from '@angular/core';

/** Banner de consejos iGuau — compatible con proyectos Angular basados en NgModules. */
@Component({
  selector: 'app-banner-blog',
  templateUrl: './banner-blog.component.html',
  styleUrls: ['./banner-blog.component.css']
})
export class BannerBlogComponent {
  /** Ruta pública del blog, absoluta desde el dominio. */
  @Input() url: string = '/blog';
  /** La imagen se sirve desde el WordPress, en la carpeta /img. */
  @Input() imagen: string = '/img/iguau-banner-blog.jpg';
  @Input() titulo: string = 'Cuida, aprende y disfruta junto a tu mascota';
  @Input() descripcion: string = 'Consejos, guías, bienestar y todo lo que necesitas para darle una vida más feliz y saludable.';
  @Input() textoBoton: string = 'Descubrir consejos';
}
